const config = require("settings/Configuration");

module.exports = function() {
    var lang = config.get("language");
    const deferred = $.Deferred();

    this.getLanguage = function() {
        return lang;
    };

    if (lang) {
        deferred.resolve();
    } else {
        $.get("/sslvpn_api/language")
            .done(function(response) {
                lang = response;
            })
            .fail(function() {
                lang = "en";
            })
            .always(function() {
                config.set("language", lang);
                deferred.resolve();
            });
    }

    return deferred.promise();
};


//////////////////
// WEBPACK FOOTER
// ./client_config/BrowserLocaleDetector.js
// module id = 122
// module chunks = 0 1 3